import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  return <section className="w-full bg-navy-light py-24 px-4 relative overflow-hidden" data-id="element-104" data-mp="3m97vrtu8wg1">
      {/* Glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-105" data-mp="8llr82li3ldv" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106" data-mp="ic6p1ntcolvq">
        <h2 className="text-3xl md:text-5xl font-headline font-bold text-white uppercase mb-8" data-id="element-107" data-mp="mejsg5kmk7pc">
          TU INVERSIÓN HOY
        </h2>

        <div className="bg-navy border border-gold/20 rounded-2xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-108" data-mp="rf7urneb0ayv">
          <div className="space-y-6 mb-10 text-lg text-gray-300" data-id="element-109" data-mp="wchfwqunu0gw">
            <p data-id="element-110" data-mp="2t5t4v3ui0p5p">
              Si intentas descifrar esto por tu cuenta, podrías gastar{' '}
              <span className="text-danger font-bold line-through" data-id="element-111" data-mp="2y3uih995nw9s">
                $3,000 a $5,000
              </span>{' '}
              al año en campamentos que son simples "máquinas de dinero".
            </p>
            <p data-id="element-112" data-mp="xwjw4jipb9p6">
              El Método "Beca Pro" no cuesta eso. Ni siquiera cuesta lo que
              pagas por un par de tacos (cleats) de gama media.
            </p>
          </div>

          <div className="bg-navy-lighter/50 rounded-xl p-8 mb-10 border border-white/5" data-id="element-113" data-mp="own88k44yev6">
            <p className="text-sm text-gray-400 uppercase tracking-widest mb-2" data-id="element-114" data-mp="1lmwaac4ji2o7">
              Inversión Única
            </p>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-115" data-mp="1gocjnyf042pi">
              <span className="text-4xl text-gray-500 line-through font-headline" data-id="element-116" data-mp="1cl6i342u2zpd">
                $97
              </span>
              <span className="text-6xl md:text-7xl font-headline font-bold text-gold text-glow" data-id="element-117" data-mp="17ljxg9koeh6j">
                $6.39 USD
              </span>
            </div>
            <p className="text-cyan text-sm font-bold animate-pulse" data-id="element-118" data-mp="3sd3uvu96hj05">
              Precio de lanzamiento por tiempo limitado
            </p>
          </div>

          <button onClick={() => {
          trackInitiateCheckout();
          window.open('https://ebookdigital.digital//cart/47440735863033:1', '_blank');
        }} className="w-full bg-gold hover:bg-gold-light text-navy-light font-headline font-bold text-2xl px-8 py-6 rounded-lg shadow-[0_0_30px_rgba(245,166,35,0.4)] transition-all transform hover:scale-[1.02] flex items-center justify-center gap-3 uppercase mb-6" data-id="element-119" data-mp="3tusqalixpvuq">
            ¡Quiero el acceso inmediato al método!
            <ArrowRight className="w-8 h-8" data-id="element-120" data-mp="316dee7v3ntnm" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-121" data-mp="364ez0x86c117">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-122" data-mp="3622k6sxpq6sd" />
            Acceso digital instantáneo
          </div>
        </div>
      </div>
    </section>;
}